import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {ApiTokenService} from '../../../services/api-token.service';
import {ColumnModel, EditSettingsModel, ToolbarItems} from '@syncfusion/ej2-angular-grids';
import {ApiToken} from '../../../models/models';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-api-token',
  templateUrl: './api-token.component.html',
  styleUrls: ['./api-token.component.css']
})
export class ApiTokenComponent implements OnInit {

  public columns: ColumnModel[];
  public allowPaging = true;
  public pageSettings = true;
  public toolbar: ToolbarItems[];
  public editSettings: EditSettingsModel;
  public dataSource: ApiToken[] = [];

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private apiTokenService: ApiTokenService
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRightStatus(1);
    this.loadDatasource();
    this.initGrid();
  }

  loadDatasource() {
    this.apiTokenService.getApiTokens().subscribe(response => {
      if (response.Ok) {
        this.dataSource = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire('Interner Server Fehler'); });
  }

  initGrid() {
    this.toolbar = ['Add', 'Edit', 'Delete', 'Cancel', 'Search'];
    this.editSettings =  { allowAdding: true, allowEditing: true, allowDeleting: true, mode: 'Normal', allowEditOnDblClick: true };
    this.columns = [
      {
        field: 'Id',
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false,
        defaultValue: '0'
      },

      {
        field: 'Value',
        headerText: 'API-Token',
        textAlign: 'Left',
        allowEditing: false
      },
      {
        field: 'Company',
        headerText: 'Firma',
        textAlign: 'Left'
      },
    ];
  }

  actionBegin(args: any) {
    if (args.action === 'add' && args.requestType === 'save') {
      args.cancel = true;
      this.apiTokenService.insertApiToken(args.data).subscribe(response => {
        if (response.Ok) {
          this.loadDatasource();
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire('Interner Server Fehler'); });
    }
    if (args.action === 'edit' && args.requestType === 'save') {
      this.apiTokenService.updateApiToken(args.data.Id, args.data).subscribe(response => {
        if (response.Ok) {
          this.loadDatasource();
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire('Interner Server Fehler'); });
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      Swal.fire({
        title: 'Löschen?',
        text: 'Möchten Sie dieses API-Token: ' + args.data[0].Company + ' wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Löschen',
        cancelButtonText: 'Abbrechen',
      }).then((confirmed) => {
        if (confirmed.value) {
          this.apiTokenService.deleteApiToken(args.data[0].Id).subscribe(response => {
            if (response.Ok) {
              this.loadDatasource();
            } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => { this.toast.fire('Interner Server Fehler'); });
        }
      });
    }
  }
}
